module.exports = __webpack_public_path__ + "img/slider-2.9f3a8f3f.jpg";